import axios from 'axios'
import Util from "../../Util.js"

var ADMIN_BACKEND_URL = process.env.VUE_APP_ADMIN_BACKEND_URL

export default class RestResource {
    async getEnquiry(params) {
        const url = `${ADMIN_BACKEND_URL}/website/enquiry/get`
        return await axios.post(url, params, Util.setupHeaders())
    }
    async getCommunityUsers(params) {
        const url = `${ADMIN_BACKEND_URL}/website/community/user/get`
        return await axios.post(url, params, Util.setupHeaders())
    }
    async getBusinessQuestions() {
        const url = `${ADMIN_BACKEND_URL}/website/business/question/fetch`
        return await axios.get(url, Util.setupHeaders())
    }
    async getRsvpData() {
        const url = `${ADMIN_BACKEND_URL}/admin/getRsvpData`
        return await axios.post(url, {}, Util.setupHeaders())
    }
}
